import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { MyService } from '../../service/my.service';

@Component({
  selector: 'app-po-auto-setting',
  templateUrl: './po-auto-setting.component.html',
  styleUrls: ['./po-auto-setting.component.scss'],
})
export class PoAutoSettingComponent implements OnInit {

  @Input() turnOverStock: any;
  @Input() turnOverOrder: any;
  @Input() counterId: number;
  @Input() listCounter: any;
  @Input() id: number;
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent;
  selectedCounter:any[];
  isReadonly = false;
  constructor(
    private modalController : ModalController,
    private myService:MyService,
    private alertController :AlertController
  ) { }

  ngOnInit() {
    if(this.id!=0){
      this.isReadonly=true;
    }
    console.log(this.counterId);
    console.log(this.listCounter);
    let selectedCounter: any = this.listCounter.find(x => x.id ==  this.counterId);
    if(selectedCounter){
      let idx =this.listCounter.indexOf(selectedCounter);
      this.selectedCounter=(this.listCounter[idx]);
    }
    this.onChangeInput('order');
    this.onChangeInput('stock');
  }
  async dismissModal(type:any) {
    let error = 0;
    let errorMessage = '';
    if(type=='s'){
      if(this.counterId==0){
        errorMessage += 'Counter harus dipilih<br>';
        error++;
      }
      console.log(this.turnOverStock);
      if(this.turnOverStock==0 || this.turnOverStock=='' || this.turnOverStock==undefined){
        errorMessage += 'Turn Over Stok harus diisi<br>';
        error++;
      }
      if(this.turnOverOrder==0 || this.turnOverOrder==''  || this.turnOverOrder==undefined){
        errorMessage += 'Turn Over Order harus diisi<br>';
        error++;
      }
      if(error!=0){
        this.showAlert(errorMessage);
      }
      else{
        let close: any[] = [];
        let productData = {
          turnOverStock: this.turnOverStock,
          turnOverOrder: this.turnOverOrder,
          counterId : this.counterId
        };
        close.push(productData);
        await this.modalController.dismiss(productData);
      }
    }
    else{
        await this.modalController.dismiss('');
      }
  }
  
  async showAlert(message: any) {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: message,
      backdropDismiss: true,
      buttons: [
        {
          text: 'OK',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }
  selectCounter(event){
    this.counterId = event.value.id;
  }

  onChangeInput(columnname:any){
    let value='';
    if(columnname=='order'){
      value= this.turnOverOrder;
    }
    else if(columnname=='stock'){
      value= this.turnOverStock;
    }
    let curWithSeparator = this.myService.separator(value);
    curWithSeparator = String(curWithSeparator).replace(/[^0-9,]/g, '');
    if(columnname=='order'){
      this.turnOverOrder = curWithSeparator;
    }
    else if(columnname=='stock'){
      this.turnOverStock = curWithSeparator;
    }
  }
  numberOnlyValidation(event: any) {
    const pattern = /[0-9.,]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
